import { heroCards, heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20cinematic%20abstract%20background%20with%20dramatic%20spotlight%20beams%20in%20a%20vintage%20theater%2C%20deep%20red%20and%20amber%20tones%2C%20textured%20haze%2C%20stylized%20artistic%20composition%2C%20empty%20stage%20without%20people%2C%20luxurious%20editorial%20atmosphere&width=1920&height=1080&seq=master-hero-2026&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/75 to-foreground-950/90" />
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 pb-16 pt-24 md:px-6 md:pb-24 md:pt-32">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-400/10 px-3 py-1 text-xs font-medium text-accent-200">
            <i className="ri-bookmark-3-line" />
            人物 IP 与师兄系列整理
          </span>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight tracking-tight text-background-50 md:text-5xl">
            大师兄影视
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            这里把师兄系列、同门电影与大师兄电影的相关信息放在一处，并补充甄子丹的动作方向，以及喜剧片与剧情片两条类型线索。全站单页呈现，按分区逐项查阅即可，不需要跳到别处。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#films"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-compasses-2-line text-base" />
              浏览题材方向
            </a>
            <a
              href="#overview"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-600"
            >
              <i className="ri-information-line text-base" />
              先看整体概览
            </a>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4 md:mt-16">
          {heroCards.map((card, i) => (
            <a
              key={card.href}
              href={card.href}
              style={{ animationDelay: `${i * 90}ms` }}
              className="group flex animate-fade-up cursor-pointer flex-col rounded-lg border border-background-50/15 bg-background-50/10 p-4 backdrop-blur-sm transition-colors hover:border-accent-400/50 hover:bg-background-50/15 md:p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500/90 text-foreground-950">
                <i className={`${card.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-background-50">
                {card.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-background-200 md:text-sm">
                {card.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-accent-200">
                前往查看
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
              </span>
            </a>
          ))}
        </div>

        <dl className="mt-12 grid grid-cols-2 gap-4 border-t border-background-50/15 pt-8 md:grid-cols-4 md:mt-16">
          {heroStats.map((stat) => (
            <div key={stat.label}>
              <dt className="font-heading text-2xl font-black text-accent-300 md:text-3xl">
                {stat.value}
              </dt>
              <dd className="mt-1 text-xs text-background-200 md:text-sm">{stat.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}